/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import { apiDataToDropdownList } from "../../../utils/sysHelpers";
import GridTable from "@nadavshaar/react-grid-table";

class Agent extends Component {
  state = {
    data: {
      fullName: "",
      tradeName: "",
      phoneNumber: "",
      governorate: "",
      address: "",
    },

    contentHeader: "الوكلاء",
    addButtonLabel: "اضافة وكيل",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetAgents",
    singleItemUrl: "/api/data/GetAgent",
    addUrl: "/api/data/AddAgent",
    editUrl: "/api/data/EditAgent",
    deleteUrl: "/api/data/DeleteCollector",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "اضافة وكيل",
    modalSubmitButtonLabelAdd: "اضافة",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "تعديل وكيل",
    modalSubmitButtonLabelEdit: "تعديل",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    allGovernorates: [],

    tableData: [],
      tableColumns: [
          {
              id: 1,
              label: "الاوامر",
              field: "SYS_ACTIONS",
              width: "100px",
              resizable: false,
              pinned: true,
              cellRenderer: ({ data }) => {
                  return (
                      <div id="outer">
                          {sysJwt.isAuthorized(["CB13"]) && (
                              <div className="inner" title="تعديل">
                                  <button
                                      className="dropdown-item btn-popup-menu"
                                      disabled={this.props.isLoading}
                                      onClick={() => {
                                          this.getEditFormData(data).then(() => {
                                              this.setState({
                                                  inEditMode: true,
                                              });
                                              this.showForm();
                                          });
                                      }}
                                  >
                                      <i className="fa fa-edit" />
                                  </button>
                              </div>
                          )}
                      </div>
                  );
              },
          },
      {
        id: 2,
        label: "ID",
          field: "ID",
          width: "100px",
      },
      {
        id: 3,
        label: "الاسم",
        field: "FULL_NAME",
      },
      {
        id: 4,
        label: "الاسم التجاري",
        field: "TRADE_NAME",
      },
      {
        id: 5,
        label: "الرصيد",
        field: "BALANCE",
      },
      {
        id: 6,
        label: "رقم الهاتف",
        field: "PHONE_NUMBER",
      },
      {
        id: 7,
        label: "المحافظة",
        field: "GOVERNORATE",
      },
      {
        id: 8,
        label: "العنوان",
        field: "ADDRESS",
      },
      {
        id: 9,
        label: "تاريخ الادخال",
        field: "INSERT_DATE",
      },
      {
        id: 10,
        label: "تاريخ التعديل",
        field: "LAST_UPDATE",
      },
    ],
  };

  componentDidMount() {
    this.getData();
    this.getAllGovernoratesDropdown();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = null);
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["fullName"] = apiResponse.data.respData.data[0].FULL_NAME;
      data["tradeName"] = apiResponse.data.respData.data[0].TRADE_NAME;
      data["phoneNumber"] = apiResponse.data.respData.data[0].PHONE_NUMBER;
      data["governorate"] = apiResponse.data.respData.data[0].GOVERNORATE_ID;
      data["address"] = apiResponse.data.respData.data[0].ADDRESS;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  getAllGovernoratesDropdown() {
    post("/api/data/GetAllGovernorates", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allGovernorates: apiResponse.data.respData.data,
        });
      }
    );
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    return (
      <div className="sys-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{this.state.contentHeader}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB12"]) && (
              <Button
                label={this.state.addButtonLabel}
                icon={this.state.addButtonIcon}
                className="p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          headerStyle={{ "background-color": "#F0F0F0", color: "black" }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode
                ? this.state.modalHeaderEdit
                : this.state.modalHeaderAdd}
            </h5>
          }
          footer={
            <div>
              <Button
                label={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonLabelEdit
                    : this.state.modalSubmitButtonLabelAdd
                }
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label="الغاء"
                icon="fa fa-close"
                className="p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "fullName",
                label: "اسم الوكيل الكامل",
                disabled: false,
              },
              {
                type: "text",
                id: "tradeName",
                label: "الاسم التجاري",
                disabled: false,
              },
              {
                type: "text",
                id: "phoneNumber",
                label: "رقم الهاتف",
                disabled: false,
              },
              {
                type: "dropdown",
                id: "governorate",
                label: "المحافظة",
                options: this.state.allGovernorates,
                disabled: false,
              },
              {
                type: "text",
                id: "address",
                label: "العنوان",
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <GridTable
          columns={this.state.tableColumns}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 30, 40]}
          showColumnVisibilityManager={false}
          texts={{
            search: "بحث:",
            totalRows: "إجمالي عدد البيانات:",
            rows: "الصف:",
            selected: "المحدد",
            rowsPerPage: "عدد الصفوف في الصفحة:",
            page: "الصفحة:",
            of: "من",
            prev: "السابق",
            next: "التالي",
            columnVisibility: "اظهار الاعمدة",
          }}
        />
      </div>
    );
  }
}

export default Agent;
